import { useTranslation } from 'react-i18next';
import Button from '@/components/Button';

const FullScreenLoading = ({ isVisible, message, redirectUrl }) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  const goToPay = () => {
    window.open(redirectUrl, '_blank');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 flex flex-col items-center gap-4 min-w-[300px]">
        {/* Loading Spinner */}
        <div className="w-12 h-12 border-4 border-[#eeeeee] border-t-[#111111] rounded-full animate-spin"></div>
        
        {/* Loading Message */}
        <div className="text-center">
          <h3 className="text-lg font-bold text-[#111111] mb-2">
            {message || t('purchase.payment.processing')}
          </h3>
          <p className="text-sm text-[#666666]">
            {t('purchase.payment.please_wait')}
          </p>
        </div>
        <Button
          variant="default"
          size="xl"
          className={`w-full h-14 rounded-[28px]`}
          onClick={goToPay}
        >
          {t('purchase.order.pay')}
        </Button>
      </div>
    </div>
  );
};

export default FullScreenLoading;
